export const companyStory = {
  eyebrow: "Nuestra historia",
  titulo: "Más de 18 años moviendo lo que importa",
  parrafos: [
    "AXONIA GROUP nació como una pequeña flota de camiones dedicada al acarreo de materiales en la zona industrial. Con el paso de los años, la confianza de nuestros clientes nos llevó a crecer y especializarnos en mudanzas, distribución, transporte de grupos y servicios especiales.",
    "Hoy operamos una flota moderna de camiones, furgonetas y autobuses, respaldada por un equipo de conductores y operadores profesionales. Nuestra prioridad sigue siendo la misma del primer día: cumplir, cuidar cada carga y responder con rapidez.",
    "Trabajamos con empresas y particulares que necesitan mover carga, personas o equipos. Cada operación se coordina de forma personalizada, con seguimiento y comunicación constante hasta la entrega.",
  ],
  imagen_url:
    "https://readdy.ai/api/search-image?query=Wide%20cinematic%20view%20of%20a%20modern%20logistics%20fleet%20of%20white%20trucks%20and%20vans%20parked%20in%20a%20clean%20terminal%20with%20the%20operations%20team%20reviewing%20a%20tablet%20in%20the%20foreground%2C%20professional%20corporate%20transport%20photography%2C%20deep%20blue%20tones%2C%20high%20detail%2C%20harmonious%20composition&width=1200&height=900&seq=axonia-about-story&orientation=landscape",
};

export const valores = [
  {
    id: "val-1",
    titulo: "Compromiso",
    descripcion:
      "Asumimos cada servicio como propio y respondemos con seriedad, cumpliendo lo que prometemos.",
    icono: "ri-hand-heart-line",
  },
  {
    id: "val-2",
    titulo: "Seguridad",
    descripcion:
      "Unidades mantenidas, amarres certificados y personal capacitado para proteger tu carga y a tu equipo.",
    icono: "ri-shield-check-line",
  },
  {
    id: "val-3",
    titulo: "Puntualidad",
    descripcion:
      "Planificamos rutas y horarios para llegar cuando lo necesitas, sin retrasos ni sorpresas.",
    icono: "ri-timer-flash-line",
  },
  {
    id: "val-4",
    titulo: "Transparencia",
    descripcion:
      "Información clara de costos, capacidades y tiempos, con comunicación directa en cada etapa.",
    icono: "ri-eye-line",
  },
  {
    id: "val-5",
    titulo: "Innovación",
    descripcion:
      "Incorporamos tecnología para coordinar operaciones, rastrear unidades y mejorar el servicio.",
    icono: "ri-lightbulb-flash-line",
  },
  {
    id: "val-6",
    titulo: "Cercanía",
    descripcion:
      "Un equipo humano que escucha, asesora y acompaña al cliente antes, durante y después del servicio.",
    icono: "ri-customer-service-2-line",
  },
];

export const equipo = [
  {
    id: "team-1",
    nombre: "Rodrigo Villanueva",
    cargo: "Director General",
    descripcion: "Lidera la estrategia y las alianzas de AXONIA GROUP desde su fundación.",
    imagen_url:
      "https://readdy.ai/api/search-image?query=Professional%20corporate%20portrait%20of%20a%20confident%20middle%20aged%20latin%20man%20in%20a%20navy%20suit%20smiling%20softly%20against%20a%20clean%20bright%20neutral%20background%2C%20soft%20studio%20lighting%2C%20cool%20blue%20tones%2C%20editorial%20business%20photography%2C%20high%20detail&width=600&height=700&seq=axonia-team-01&orientation=portrait",
  },
  {
    id: "team-2",
    nombre: "Patricia Salazar",
    cargo: "Jefa de Operaciones",
    descripcion: "Coordina rutas, unidades y tiempos para cumplir cada servicio con precisión.",
    imagen_url:
      "https://readdy.ai/api/search-image?query=Professional%20corporate%20portrait%20of%20a%20confident%20latin%20woman%20with%20glasses%20in%20a%20light%20blazer%20smiling%20warmly%20against%20a%20clean%20bright%20neutral%20background%2C%20soft%20studio%20lighting%2C%20cool%20blue%20tones%2C%20editorial%20business%20photography%2C%20high%20detail&width=600&height=700&seq=axonia-team-02&orientation=portrait",
  },
  {
    id: "team-3",
    nombre: "Miguel Acosta",
    cargo: "Jefe de Flota",
    descripcion: "Mantiene cada vehículo en óptimas condiciones y supervisa la seguridad operativa.",
    imagen_url:
      "https://readdy.ai/api/search-image?query=Professional%20corporate%20portrait%20of%20a%20latin%20man%20in%20a%20dark%20polo%20shirt%20with%20arms%20crossed%20smiling%20confidently%20against%20a%20clean%20bright%20neutral%20background%2C%20soft%20studio%20lighting%2C%20cool%20blue%20tones%2C%20editorial%20business%20photography%2C%20high%20detail&width=600&height=700&seq=axonia-team-03&orientation=portrait",
  },
  {
    id: "team-4",
    nombre: "Ana Beltrán",
    cargo: "Atención al Cliente",
    descripcion: "Escucha cada necesidad y guía al cliente en la elección de la unidad adecuada.",
    imagen_url:
      "https://readdy.ai/api/search-image?query=Professional%20corporate%20portrait%20of%20a%20young%20latin%20woman%20with%20a%20friendly%20smile%20wearing%20a%20light%20shirt%20against%20a%20clean%20bright%20neutral%20background%2C%20soft%20studio%20lighting%2C%20cool%20blue%20tones%2C%20editorial%20business%20photography%2C%20high%20detail&width=600&height=700&seq=axonia-team-04&orientation=portrait",
  },
];

export const hitos = [
  { id: "h-1", valor: "2008", etiqueta: "Inicio de operaciones" },
  { id: "h-2", valor: "2014", etiqueta: "Primera flota propia" },
  { id: "h-3", valor: "2019", etiqueta: "Servicios para eventos y grupos" },
  { id: "h-4", valor: "2024", etiqueta: "Cobertura nacional y flota renovada" },
];